import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import PreLoginPage from '../../../views/core/PreLoginPage';
import HmEventRegistry from '../../../model/HmEventRegistry';
import UserStorageUtil from '../../../util/UserStorageUtil';

// ES6 class-style
class Lessons extends PreLoginPage {

	constructor(props) {
	    super(props);
	    this.state = {
	      products_details: {},
	    }
	    this.productDetails = localStorage.getItem('proDetail');
	    this.gradeID = localStorage.getItem('grade');
		this.proID = localStorage.getItem('product');
		this.url = this.gradeID+'.json';
		
		this.openLesson = this.openLesson.bind(this);
	  }


	componentDidMount() {
		var me = this;
		this.proID = localStorage.getItem('product');
		HmEventRegistry.fireEvent("INITIATE_GA");
	}

	getProductDetails(){
		//console.log(JSON.parse(this.productDetails));
	    if(this.productDetails != {} && this.productDetails != undefined){
	      return JSON.parse(this.productDetails);
	    }
	}
	 
  openLesson(event){
	  var lesIndex = event.currentTarget.dataset.index;
	  
	  this.proID = localStorage.getItem('product');
	  	const samples = JSON.parse(this.getProductDetails()[this.proID].productDetails);
	  	const gradeName = this.getProductDetails()[this.proID].ClassName;
	  	const samplesLessons = samples[0].samples;
	  	//console.log(samplesLessons[lesIndex]);
	  	
	  	var lessonidTracking = samplesLessons[lesIndex].lessonUrl;
		var lessonid = samplesLessons[lesIndex].lessonUrl;
		var lessonname = samplesLessons[lesIndex].name;
		var lurl = samplesLessons[lesIndex].lessonUrl;
		var dd = 0;
		var lessonPref = null;
		var testid = null;
		var topicSubTopicMapId = null;
		var accessId = null;
		var classId = null;
		var snippetId = "";
		var source = 0;
		var lessonviewRoute = "/openlessonview";
		
		if(this.props.PLPloggedIn || this.props.PLPloggedIn == "true"){
			lessonviewRoute = "/lessonview";
		}
		
		var _url = lessonviewRoute+"/"+lessonid+"?url="+lurl+"&lessonPref="+lessonPref+"&testid="+testid+"&revisiontopicid="+topicSubTopicMapId+"&accessId="+accessId+"&classId="+classId+"&src=plp"+"&lessonidTracking="+lessonidTracking+"&tracksource="+this.props.tracksource+"&snid="+snippetId+"&qsrc="+source;
		  if(dd > 0){
		    _url += "&dd="+dd;
		  }
	
		  UserStorageUtil.storeSessionItem(lurl,lessonname);
		//console.log(_url);
		window.open(_url,lessonid,'fullscreen=yes,menubar=no,width='+window.innerWidth+',height='+window.innerHeight).focus();
	  	
  }
  render() {

  	this.proID = localStorage.getItem('product');
  	const samples = JSON.parse(this.getProductDetails()[this.proID].productDetails);
  	const gradeName = this.getProductDetails()[this.proID].ClassName;
  	const samplesLessons = samples[0].samples;
  	//console.log(this.proID);
  	console.log(samples);

  	try{
	  	if(samplesLessons.length != 0){
			  this.stitle = <h2 className="spl-lessons">Sample Lessons</h2>;
	  		// this.stitle = <h4>Sample Lessons for {this.getProductDetails()[this.proID].ClassName}</h4>;
	  	}
  	}catch(e){}
  	

  	return(
	<section className="product-main">
	 	<div className="container">  
	 	 	{this.stitle} 
	 	 	<div className="row"> 
			
			{Object.keys(samplesLessons).map((v, i) => 

		    	

		    	<div className="col-md-12" key={i}>
		    		<a data-ga={"SPL - Sample Lessons for "+gradeName+" - "+samplesLessons[i].name}>
						<div className="sample-les samplelessonbox" data-index={i} onClick={this.openLesson}>
							<div className="sampl-img lessonthumb"><img src={"/"+samplesLessons[i].image} alt={samplesLessons[i].name + " - HeyMath! lesson"}/><span className="play-btn"></span></div>
							<div className="sampl-text">
								<h3>{samplesLessons[i].name}</h3>
								<p>{samplesLessons[i].Description}</p>
							</div>							
							<div className="clear"></div>
						</div>	
					</a>
				</div>

			)}

											
	 	 	</div>
	 	</div> 
	 </section> 
  	);
  }
}

export default Lessons; 



// WEBPACK FOOTER //
// ./src/prelogin/src/components/Lessons.js